<div>
  <h2>{{ 'Generera bilder' | translate }}</h2>

  <div class="row" *ngIf="!result">
    <div class="col">
      <mat-form-field class="fullwidth">
        <label>{{ 'Text' | translate }}</label>
        <input matInput [(ngModel)]="prompt">
      </mat-form-field>
      <div>{{prompt.length}}/1000 tecken</div>
    </div>
    <div class="col">
      <br />
      <button mat-raised-button [disabled]="generating" color="primary" (click)="generate()">{{ 'Generera' | translate }}</button>
    </div>
  </div>

  <div *ngIf="result">
    <div class="row">
      <div class="col">
        <h3>{{ 'Resultat' | translate }}</h3>
        <h5>"{{prompt}}"</h5>
      </div>
      <div class="col">
        <mat-checkbox [(ngModel)]="viewPosterBorders">{{ 'Visa posterkanter' | translate }}</mat-checkbox>
      </div>
    </div>
    <div class="row result">
      <div class="col-6 align-center" *ngFor="let image of result.images; let i = index">
        <div class="image-wrapper">
          <img [src]="image.safeUrl" />
          <div class="poster-size _21x30" *ngIf="viewPosterBorders"></div>
          <div class="poster-size _30x40" *ngIf="viewPosterBorders"></div>
          <div class="poster-size _50x70" *ngIf="viewPosterBorders"></div>
        </div>
        <br />
        <br />
        <span class="material-symbols-outlined spinning" *ngIf="image.upscaling">sync</span>
        <button mat-raised-button *ngIf="!image.createdPoster && !image.upscaling && !image.upscaledUrl"
          [disabled]="upscaling" color="primary" (click)="upscale(i)">{{ 'Skala upp' | translate }}</button>
        &nbsp;
        <button mat-raised-button [disabled]="image.creatingPoster" *ngIf="!image.creatingPoster && !image.createdPoster" [disabled]="upscaling"
          color="primary" (click)="createPoster(i)">{{ 'Skapa poster' | translate }}</button>



        <span *ngIf="image.createdPoster">
          <a target="_blank" *ngIf="image.createdPoster"
            [routerLink]="[globals.panelUrl('/posters/' + image.createdPoster._id)]">
            <button mat-raised-button color="primary">{{ 'Visa poster' | translate }}</button>
          </a>
          &nbsp;
          <button
            *ngIf="!image.creatingPoster && (!image.createdPoster.thirdParty || !image.createdPoster.thirdParty.shopify || !image.createdPoster.thirdParty.shopify.productId)"
            mat-raised-button [disabled]="image.creatingShopifyProduct" color="primary"
            (click)="createShopifyProduct(image)">{{ 'Skapa Shopify-produkt' | translate }}</button>

          <a *ngIf="image.createdPoster.thirdParty && image.createdPoster.thirdParty.shopify && image.createdPoster.thirdParty.shopify.productId"
            [href]="'https://admin.shopify.com/store/' + globals.storeSettings.shopifySettings.shopName.replace('.myshopify.com', '') + '/products/' + image.createdPoster.thirdParty.shopify.productId"
            target="_blank">
            <button mat-raised-button color="primary">{{ 'Visa Shopify-produkt' | translate }}</button>
          </a>

        </span>



        <br />
        <br />
      </div>
    </div>

    <button mat-raised-button color="primary" [disabled]="upscaling" class="fullwidth" (click)="startOver()">{{ 'Börja om' | translate }}</button>
  </div>

</div>
